import React, { useEffect, useMemo, useState } from 'react';
import clientService from 'services/http/client-service';
import utils, { INTERVENTION_STATUS } from 'utils';
import { AttachementTemplate } from 'components/layout/sidebar';
import { Badge, Popup, SkeletonLoader, UserAvatar, LazyLoadingWithPagination } from 'components/shared';
import { TaskMessages } from "components/pages/tasks-page/task-messages";
import $ from "jquery";

export const ClientHistory = (props) => {

    const [displayMessages, setDisplayMessages] = useState();
    const [targetTask, setTargetTask] = useState();
    const data = props.data;

    useEffect(() => {
        utils.fixContainersOverlaping(".tasks-content");
    }, []);

    //HISTOTY TASK ITEM TEMPLATE
    const TaskItem = (props) => {
        let task = props.task;
        let senderLastMsg = task.lastMessage.direction === "incoming" ? <small className="font-weight-bold" style={{ color: "#60C1E6" }}>{utils.shorthandString(`${task.client.firstname} ${task.client.lastname}`, 12)}</small> : <small className="font-weight-bold" style={{ color: "gray" }}>Agent {task.lastMessage.username ? utils.shorthandString(task.lastMessage.username.toUpperCase(), 10) : ``}</small>;
        let receiverLastMsg = task.lastMessage.direction === "outgoing" ? <small className="font-weight-bold" style={{ color: "#60C1E6" }}>{utils.shorthandString(`${task.client.firstname} ${task.client.lastname}`, 12)}</small> : <small className="font-weight-bold" style={{ color: "gray" }}>Agent {task.lastMessage.username ? utils.shorthandString(task.lastMessage.username.toUpperCase(), 10) : ``}</small>;

        const onTaskViewClick = (e) => {
            e.preventDefault();
            setDisplayMessages(true);
            setTargetTask(task);
        }

        return (
            <div className="history-task-item d-flex w-100">
                <UserAvatar
                    size="small" shape="circle"
                    image={task.lastMessage.direction === "incoming" ? task.client.profilePic : null}
                    label={task.lastMessage.direction === "outgoing" ? task.lastMessage.username?.substring(0, 2).toUpperCase() : null}
                    icon={(task.lastMessage.direction === "outgoing" && task.lastMessage.username === null) ? utils.guessSourceIcon(task.source.sourceId) : null}
                />
                <div className="text-justify mx-1 w-100">
                    {/* TASK HEADER BODY */}
                    <div className="w-100 d-flex justify-content-between">
                        <span className="pl-">{senderLastMsg} <i className="bi bi-caret-right-fill" style={{ fontSize: "12px", color: "gray" }} /> {receiverLastMsg}</span>&nbsp;
                        <span>
                            <span className="mx-1"><TaskStatusTemplate status={task.status} /></span>
                            <i className={`${utils.guessSourceIcon(task.source.sourceId)} task-source-icon`} />
                        </span>
                    </div>
                    {/* TASK DATE & TAGS BODY */}
                    <div className="w-100 d-fle justify-content-betwee">
                        <span>
                            {
                                task.tags.map((tag) => {
                                    return <TaskTagTemplate value={tag.description} color={`#${tag.color}`} />
                                })
                            }
                        </span>
                    </div>
                    {/* TASK LAST MESSAGE CONTENT */}
                    <div className="justify-content-between d-flex mx-1 w-100 " >
                        <span>
                            {
                                task.lastMessage.withAttachment === 1 ?
                                    <AttachementTemplate type={task.lastMessage.attachments[0].attachmentType} />
                                    : <small>{utils.shorthandString(task.lastMessage.content)}</small>
                            }
                        </span>
                        <small>
                            <small className="font-weight-bold mr-1" style={{ fontSize: "11px" }}> {new Date(task.statusDate).toLocaleString()} </small>
                            <a href="/#" onClick={onTaskViewClick}> View detail </a>
                        </small>
                    </div>
                </div>
            </div>
        )
    }

    //EMPTY HISTORY TASKS TEMPLATE
    const EmptyHistoryItems = () => {
        return (
            <div className="text-center m-3">
                <i className="bi bi-exclamation-circle" style={{ fontSize: "30px" }} /><br />
                <span>No history yet</span>
            </div>
        )
    }

    //TOTAL HISTORY TASKS TEMPLATE
    const TotalHistoryTemplate = () => {
        return (
            <>
                {
                    data &&
                    <div className="text-center">
                        <i className="bi bi-chat-dots" /> <small>{data.totalElements} tasks has been opened</small>
                        <hr />
                    </div>
                }
            </>
        )
    }

    return (
        <div className={`${props.taskView && 'scroll-container'} tasks-content`}>
            {
                data.interventions?.length ?
                    <div>
                        <TotalHistoryTemplate />
                        {
                            data.interventions.map((item) => {
                                return (
                                    <TaskItem task={item} />
                                );
                            })
                        }
                    </div> : <EmptyHistoryItems />
            }

            <Popup
                header="Task history"
                visible={displayMessages}
                dismissableMask
                sticked
                onHide={() => setDisplayMessages(false)}>
                <div style={{ width: "50vw" }}>
                    <TaskMessages task={targetTask} />
                </div>
            </Popup>
            {props.children}
        </div >
    );
}

//INTERVENTION STATUS TAG
export const TaskStatusTemplate = (props) => {
    let statusId = props.status.statusId.toUpperCase();
    switch (statusId.toLowerCase()) {
        case (INTERVENTION_STATUS.INITIATED): {
            return <Badge servirity="secondary" data={statusId} icon="bi bi-bookmark-plus" />
        }
        case (INTERVENTION_STATUS.ACCEPTED): {
            return <Badge servirity="primary" data={statusId} icon="bi bi-bookmark-check" />
        }
        case (INTERVENTION_STATUS.IN_PROGRESS): {
            return <Badge servirity="danger" data={statusId} icon="bi bi-hourglass-top" />
        }
        case (INTERVENTION_STATUS.COMPLETED): {
            return <Badge servirity="success" data={statusId} icon="bi bi-check-circle" />
        }
        case (INTERVENTION_STATUS.ARCHIVED): {
            return <Badge servirity="warning" data={statusId} icon="bi bi-archive" />
        }
        case (INTERVENTION_STATUS.ABORTED): {
            return <Badge servirity="secondary" data={statusId} icon="bi bi-x-circle" />
        }
        case (INTERVENTION_STATUS.DEFFERRED): {
            return <Badge servirity="secondary" data={statusId} icon="bi-arrow-up-right-circle" />
        }
        default: {
            return <Badge servirity="secondary" data={statusId} />
        }
    }
}

//INTERVENTION TAG TEMPLATE
export const TaskTagTemplate = (props) => {
    $(() => {
        $('[data-toggle="tooltip"]').tooltip()
    });
    return <span className="mr-1" style={{ color: "white" }} data-toggle="tooltip" title={props.value}><Badge className="p-mr-2" bgColor={props.color} data={`#${utils.shorthandString(props.value, 7)}`}></Badge></span>
}

export const ClientHistoryHoc = (props) => {

    const { task } = props;

    const MemorisedClientHistoryHoc = useMemo(
        () => LazyLoadingWithPagination(
            ClientHistory,
            clientService.getClientHistory,
            { clientId: task.client.clientId, pageIndex: 0 },
            "interventions",
            <SkeletonLoader factor={5} />)(props), [task.interventionId, task.status.statusId]);

    return <MemorisedClientHistoryHoc />
}